import Divider from '../components/ui/Divider';

const articleClassName = 'text-mainWhite text-xl flex flex-col gap-5';
const boldParagraphClassName = 'font-bold';
const unorderedListClassName = 'flex flex-col gap-5 list-disc ms-10';

const TermsPage = () => {
  return (
    <div className="flex flex-col px-8 my-10 gap-10">
      <article className={articleClassName}>
        <p className={boldParagraphClassName}>
          📝 Общи условия за ползване на платформата Bolarena
        </p>
        <p>
          Настоящите Общи условия уреждат използването на уеб платформата и
          мобилното приложение Bolarena (наричани по-долу „Платформата“),
          собственост на [име на юридическо лице, адрес, ЕИК], предоставяща
          услуги по организация и участие в спортни събития.
        </p>
        <p>
          С достъпа и/или регистрацията в Платформата, потребителят декларира,
          че е запознат с настоящите Общи условия и ги приема изцяло.
        </p>
      </article>

      <Divider />

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>1. Информация за услугата</p>
        <p>
          Bolarena е дигитална платформа, която улеснява организацията и
          участието в спортни занимания – като футбол, а скоро и тенис,
          баскетбол и други – чрез предоставяне на информация за налични спортни
          обекти и възможност за резервация на часове, създаване на групи и
          координация между потребителите. При наличие на автоматизирана система
          за резервации, платформата може директно да извършва резервации от
          името на потребителя чрез съответния спортен обект.
        </p>
      </article>

      <Divider />

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>2. Определения</p>
        <ul className={unorderedListClassName}>
          <li>
            <b>Платформа</b> - уебсайтът и/или мобилното приложение на Bolarena
          </li>
          <li>
            <b>Потребител</b> - всяко физическо или юридическо лице, използващо
            услугите на Платформата
          </li>
          <li>
            <b>Организатор</b> - потребител, капитан, който създава спортно
            събитие чрез платформата
          </li>
          <li>
            <b>Участник</b> – потребител, играч който се записва за участие в
            събитие
          </li>
          <li>
            <b>Спортен обект</b> – място за провеждане на спортни занимания
            (игрища, зали и др.)
          </li>
          <li>
            <b>Bolarena</b> – собственикът и администраторът на платформата
          </li>
        </ul>
      </article>

      <Divider />

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>3. Регистрация и достъп</p>
        <p>
          Регистрацията в Bolarena е доброволна и безплатна. Потребителят се
          задължава да предостави вярна, пълна и актуална информация.
          Потребителят носи отговорност за сигурността на своите достъпни данни
          (потребителско име и парола).
        </p>
      </article>

      <Divider />

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>
          4. Резервации и организация на събития
        </p>
        <ul className={unorderedListClassName}>
          <li>
            Всеки потребител може да се запише за участие в организирано спортно
            събитие чрез избран обект, определен час и дата.
          </li>
          <li>
            Организаторът носи отговорност за реалната резервация на терена, ако
            платформата не осигурява автоматична такава.
          </li>
          <li>Плащане се извършва само и единствено на място.</li>
          <li>
            Bolarena не е страна по договорните отношения между потребители и
            спортни обекти и не носи отговорност за ангажименти между тях,
            включително наемни отношения или ангажименти за плащания.
          </li>
        </ul>
      </article>

      <Divider />

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>
          5. Съдържание, споделяно от потребителите
        </p>
        <p>
          Потребителите носят пълна отговорност за всяко съдържание (текст,
          изображения, коментари), което публикуват в Платформата. Bolarena си
          запазва правото да премахва или блокира съдържание, което нарушава
          закона, морала или добрите нрави, по сигнал или по собствена преценка.
        </p>
        <p>
          С публикуването на съдържание в Платформата, потребителят предоставя
          на Bolarena неограничено по време и територия право да използва,
          публикува, адаптира и разпространява това съдържание за нуждите на
          Платформата.
        </p>
      </article>

      <Divider />

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>
          6. Връзки между потребители и спортни обекти
        </p>
        <p>
          Bolarena не е страна в договорните отношения между потребителите и
          собствениците на спортни обекти. Всички условия по достъпност, наем,
          състояние и безопасност на обектите са извън отговорността на
          Платформата.
        </p>
      </article>

      <Divider />

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>7. Ограничения и забрани</p>
        <p>Забранява се:</p>
        <ul className={unorderedListClassName}>
          <li>Организиране на събития без реална резервация на обект</li>
          <li>Публикуване на фалшиви или подвеждащи събития</li>
          <li>
            Използване на платформата за рекламни цели без изрично съгласие
          </li>
          <li>Създаване на повече от един профил на лице</li>
          <li>Използване на обидно, агресивно или незаконно съдържание</li>
          <li>Нарушаване на авторски и интелектуални права</li>
        </ul>
      </article>

      <Divider />

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>8. Отказ от отговорност</p>
        <p>
          Платформата се предоставя „в съществуващия си вид“. Bolarena не
          гарантира непрекъсната достъпност, липса на грешки или технически
          неизправности.
        </p>
        <p>Bolarena не носи отговорност за:</p>
        <ul className={unorderedListClassName}>
          <li>
            Злополуки, наранявания или щети, възникнали по време на спортно
            събитие, освен ако не е доказано, че те са причинени от умишлено или
            грубо небрежно поведение на Bolarena
          </li>
          <li>Отказ на участник да се яви или да плати своята част</li>
          <li>
            Закъснения, отменени резервации или технически проблеми в системата
          </li>
        </ul>
      </article>

      <Divider />

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>9. Прекратяване на достъп</p>
        <p>
          Bolarena си запазва правото да прекрати или ограничи достъпа на
          потребител, който нарушава настоящите условия или създава правни,
          репутационни или технически рискове за платформата и останалите
          потребители.
        </p>
      </article>

      <Divider />

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>
          10. Поверителност и лични данни
        </p>
        <p>
          Използването на лични данни се регулира от Политиката за
          поверителност, достъпна на сайта. Платформата обработва лични данни
          съгласно Закона за защита на личните данни и Общия регламент за защита
          на данните (GDPR).
        </p>
      </article>

      <Divider />

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>
          11. Приложимо право и юрисдикция
        </p>
        <p>
          Настоящите Общи условия се уреждат от българското законодателство.
          Всички спорове се разрешават от компетентния съд в Република България.
        </p>
      </article>

      <Divider />

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>12. Изменения на условията</p>
        <p>
          Bolarena има право да променя настоящите Общи условия, като извести
          потребителите чрез платформата или по имейл. Измененията влизат в сила
          в срок от 7 дни след публикуване, освен ако не е посочено друго.
          Продължаването на ползването на услугата след този срок се счита за
          съгласие с направените промени.
        </p>
      </article>

      <Divider />

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>🔐 Политика за поверителност</p>
        <p>
          Настоящата Политика за поверителност има за цел да ви информира за
          начина, по който Bolarena събира, използва, съхранява и защитава
          вашите лични данни, когато използвате платформата.
        </p>
      </article>

      <Divider />

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>Администратор на лични данни</p>
        <p>[попълнете име, адрес, имейл]</p>
      </article>

      <Divider />

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>Видове събирани лични данни</p>
        <ul className={unorderedListClassName}>
          <li>Име и фамилия</li>
          <li>Телефонен номер</li>
          <li>Прякор</li>
          <li>Години</li>
          <li>Потребителска снимка</li>
          <li>Град</li>
          <li>Парола (шифрирана)</li>
          <li>Позиция за игра</li>
          <li>Данни за използване и бисквитки (Cookies)</li>
        </ul>

        <p>
          Допълнителна информация може да се предоставя контекстуално в процеса
          на събиране на данни.
        </p>
      </article>

      <Divider />

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>
          Основания за обработка на данни
        </p>
        <ul className={unorderedListClassName}>
          <li>Изпълнение на договор/услуга (чл. 6, ал. 1, б. "б" от GDPR)</li>
          <li>Съгласие (чл. 6, ал. 1, б. "а")</li>
          <li>
            Законен интерес (напр. за защита от злоупотреби или статистика)
          </li>
          <li>Правно задължение</li>
        </ul>
      </article>

      <Divider />

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>Цели на обработката</p>
        <ul className={unorderedListClassName}>
          <li>Регистрация и удостоверяване на потребители</li>
          <li>Осигуряване на достъп до функционалности</li>
          <li>Подобряване на потребителското изживяване</li>
          <li>Анализ и статистика (напр. чрез Google Analytics)</li>
          <li>Комуникация и поддръжка</li>
          <li>Свързване със социални мрежи (Facebook и др.)</li>
          <li>Изпращане на известия, свързани с платформата</li>
          <li>Рекламни и маркетингови цели (само със съгласие)</li>
        </ul>
      </article>

      <Divider />

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>
          Бисквитки и технологии за проследяване
        </p>
        <p>Използваме бисквитки с цел:</p>
        <ul className={unorderedListClassName}>
          <li>Идентификация на потребителя</li>
          <li>Запазване на предпочитания</li>
          <li>Анализ на трафика</li>
          <li>Персонализирана реклама (само със съгласие)</li>
        </ul>
        <p>
          Можете да управлявате бисквитките чрез настройките на браузъра си.
        </p>
      </article>

      <Divider />

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>Съхранение на данните</p>
        <p>
          Данните се съхраняват толкова дълго, колкото е необходимо за
          предоставяне на услугите, освен ако не е изискано по-дълго съхранение
          съгласно закона. Можете да поискате изтриване на данните по всяко
          време.
        </p>
      </article>

      <Divider />

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>Споделяне на данни</p>
        <p>Вашите данни може да се споделят със:</p>
        <ul className={unorderedListClassName}>
          <li>Доставчици на хостинг и IT услуги</li>
          <li>Аналитични и маркетингови партньори (напр. Google, Facebook)</li>
          <li>Административен екип, партньори и подизпълнители</li>
          <li>Държавни органи при законово задължение</li>
        </ul>
      </article>

      <Divider />

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>Права на потребителите</p>
        <p>Вие имате право да:</p>
        <ul className={unorderedListClassName}>
          <li>Достъп до личните ви данни</li>
          <li>Коригиране или изтриване на данни</li>
          <li>Ограничаване на обработката</li>
          <li>Възразите срещу обработка</li>
          <li>Преносимост на данни</li>
          <li>Оттегляне на съгласие по всяко време</li>
          <li>Подаване на жалба до КЗЛД</li>
        </ul>
        <p>
          За упражняване на тези права, можете да се свържете с нас чрез имейл:
          [въведете имейл]. Отговаряме в срок до 30 дни.
        </p>
      </article>

      <Divider />

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>Сигурност</p>
        <p>
          Прилагаме технически и организационни мерки за защита на данните ви от
          неразрешен достъп, загуба или злоупотреба.
        </p>
      </article>

      <Divider />

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>Връзки със социални мрежи</p>
        <p>
          Ако се свържете с профил във Facebook или друга мрежа, платформата ще
          получи данни съгласно вашите настройки в съответната услуга.
        </p>
      </article>

      <Divider />

      <article className={articleClassName}>
        <p className={boldParagraphClassName}>Промени в политиката</p>
        <p>
          Bolarena си запазва правото да актуализира тази политика. Всички
          промени ще бъдат публикувани тук. Продължаването на ползването на
          платформата се счита за приемане на новите условия.
        </p>
      </article>
    </div>
  );
};

export default TermsPage;
